// extracted by mini-css-extract-plugin
export default {"content":"drawer_content__WmCvp","body":"drawer_body__BOuUG","header":"drawer_header__BKbaU","footer":"drawer_footer__642Za"};